import { getWindow } from '@shared/lib/utils';

export const loadState = state => {
  try {
    const serializedState = getWindow().localStorage.getItem(state);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (key, state) => {
  try {
    const serializedState = JSON.stringify(state);
    getWindow().localStorage.setItem(key, serializedState);
  } catch (err) {
    // die
  }
};
